import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function Main() {
  const navigate = useNavigate();
  useEffect(() => navigate("/notes"), [navigate]);
  return <Box sx={{ marginTop: 2 }}>You are at the home page.</Box>;
}
